import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconLogoutLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.308 20.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283V5.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h5.952c.212 0 .39.072.534.216a.726.726 0 0 1 .215.534.726.726 0 0 1-.215.535.726.726 0 0 1-.534.215H5.308a.294.294 0 0 0-.212.096.294.294 0 0 0-.096.212v13.384c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h5.952c.212 0 .39.072.534.215a.726.726 0 0 1 .215.535.726.726 0 0 1-.215.535.726.726 0 0 1-.534.215H5.308Zm12.31-7.75H9.845a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.391.216-.534a.726.726 0 0 1 .534-.216h7.771l-1.923-1.923a.706.706 0 0 1-.212-.507.739.739 0 0 1 .212-.531.72.72 0 0 1 .527-.241.718.718 0 0 1 .543.225l3.094 3.094c.18.181.27.392.27.633s-.09.452-.27.633l-3.095 3.094a.713.713 0 0 1-.53.22.75.75 0 0 1-.539-.236.731.731 0 0 1-.21-.534.735.735 0 0 1 .226-.52l1.907-1.907Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconLogoutLine;
